import { Controller } from 'stimulus';
import tinymce from 'tinymce/tinymce';

export default class extends Controller {
    static targets = ['editor', 'addButton', 'form'];

    connect() {
        this.checkContent();
    }

    checkContent() {
        const textarea = document.getElementById('lesson_note_user_content');
        if (textarea && textarea.value.trim().length > 0) {
            this.showEditor();
        } else {
            this.showAddButton();
        }
    }

    syncTinymce(event) {
        if (typeof tinymce !== 'undefined') {
            tinymce.triggerSave();
        }
    }

    showEditor() {
        this.editorTarget.classList.remove('hidden');
        this.addButtonTarget.classList.add('hidden');
    }

    showAddButton() {
        this.editorTarget.classList.add('hidden');
        this.addButtonTarget.classList.remove('hidden');
    }

    toggleEditor() {
        this.showEditor();
    }
}
